module.exports = __webpack_public_path__ + "media/img/avatars/profiles/avatar-7-ca42356249973b291183bff0ee1f0cbe.jpg";